<y42-chat-room
  *ngIf="!state.isLoading; else loading"
  [conversation]="state.chatRoomConversation"
  [author]="state.chatAuthor"
  [isResolveable]="state.isResolveable"
  [mentionUsers]="state.mentionUsers"
  [moveToMessageId]="state.moveToMessageId"
  (edited)="onChatRoomMessageEdited($event)"
  (commented)="onChatRoomCommented($event)"
  (deleted)="onChatRoomMessageDeleted($event)"
  (resolved)="onChatRoomResolved()"
  (moveToMessageIdConsumed)="onMoveToMessageIdConsumed()"
></y42-chat-room>

<ng-template #loading>
  <y42-logo-loader class="flex justify-center items-center h-full"></y42-logo-loader>
</ng-template>
